import React, { useState } from 'react'

import { Typography } from '@material-ui/core'
import Modal from 'ui/components/Modal'

import styles from './styles'

export default ({
  title,
  imagePath,
}) => {
  const classes = styles({ imagePath: imagePath })

  const [modalOpen, setModalOpen] = useState(false)

  const handleToggleModal = () => {
    setModalOpen(!modalOpen)
  }

  return (
    <div>
      <div
        className={classes.container}
        onClick={handleToggleModal}
      >
        <div className={classes.containerTitle}>
          <Typography>{title}</Typography>
        </div>
      </div>

      <Modal
        open={modalOpen}
        onClose={handleToggleModal}
        title={title}
      >
        <div>
          <img
            className={classes.modalImg}
            src={imagePath}
            alt="imagem"
          />
        </div>
      </Modal>
    </div>
  )
}
